export default {
  path: "/about",
  meta: {
    title: "关于我们",
  },
  component: () => import("@/views/common/moduleMain.vue"),
  children: [
    {
      path: "/introduce/:menuId",
      meta: {
        title: "企业简介",
        contentType: "c-4",
        sortType: "s-208",
      },
      component: () => import("@/views/about/introduce.vue"),
    },
    {
      path: "/cultural/:menuId",
      meta: {
        title: "文化与价值观",
        contentType: "c-4",
        sortType: "s-209",
      },
      component: () => import("@/views/about/cultural.vue"),
    },
    {
      path: "/develop/:menuId",
      meta: {
        title: "发展历程",
        contentType: "c-4",
        sortType: "s-210",
      },
      component: () => import("@/views/about/develop.vue"),
    },
    {
      path: "/duty/:menuId",
      meta: {
        title: "社会责任",
        contentType: "c-4",
        sortType: "s-211",
      },
      component: () => import("@/views/about/duty.vue"),
    },
    {
      path: "/power/:menuId",
      meta: {
        title: "核心竞争力",
        contentType: "c-4",
        sortType: "s-212",
      },
      component: () => import("@/views/about/power.vue"),
    },
    {
      path: "/team/:menuId",
      meta: {
        title: "团队管理",
        contentType: "c-4",
        sortType: "s-213",
      },
      component: () => import("@/views/about/team.vue"),
    },
  ],
};
